export default {
  nav: {
    solutions: 'Solutions',
    cases: 'Case Studies',
    kol: 'KOL Partnership',
    contact: 'Contact Us',
    login: 'Enterprise Login'
  },
  hero: {
    badge: 'AI-Powered Real-Time Communication',
    title: 'Ultimate Real-Time Communication for Global Gaming Companies',
    subtitle: 'Deep integration of AI algorithms and WebRTC, providing ultra-low latency, high-definition audio and video solutions for game developers, supporting cross-platform interaction, real-time voice translation, and intelligent video optimization',
    cta: 'Start Free Trial',
    learn: 'Learn More',
    latency: 'Ultra-Low Latency',
    nodes: 'Global Nodes',
    uptime: 'Uptime'
  },
  features: {
    title: 'Core Technology Advantages',
    subtitle: 'Deep integration of AI and WebRTC for ultimate gaming communication experience',
    ai: {
      title: 'AI Smart Optimization',
      desc: 'Intelligent noise reduction, echo cancellation, and video enhancement for crystal-clear communication'
    },
    translate: {
      title: 'Real-Time Translation',
      desc: 'Support multi-language real-time translation, breaking language barriers and connecting global players'
    },
    global: {
      title: 'Global Node Coverage',
      desc: '200+ global nodes with intelligent routing for lowest latency and best connection quality'
    },
    security: {
      title: 'Enterprise-Grade Security',
      desc: 'End-to-end encryption, secure and reliable data, compliant with international privacy standards'
    }
  },
  solutions: {
    title: 'Solutions',
    subtitle: 'Professional audio and video communication solutions for different gaming scenarios',
    streaming: {
      title: 'Game Streaming Solution',
      desc: 'Provide ultra-HD, low-latency streaming technology for game streamers, supporting millions of concurrent viewers with real-time interaction and zero lag. AI-powered beauty filters and effects make streams more engaging.',
      f1: 'Ultra-HD 4K streaming with 25ms latency',
      f2: 'AI beauty filters and real-time effects',
      f3: 'Support millions of concurrent viewers'
    },
    voice: {
      title: 'Team Voice Solution',
      desc: 'Professional team voice communication for competitive games like MOBA and Battle Royale, supporting spatial audio positioning for precise teammate location. AI noise reduction ensures clear communication.',
      f1: '3D spatial audio for precise positioning',
      f2: 'AI noise reduction eliminates background noise',
      f3: 'Support 100 simultaneous voice users'
    },
    social: {
      title: 'Social Interaction Solution',
      desc: 'Multi-person video calls, virtual gifts, and real-time interaction for social games. Support real-time voice translation for seamless communication between players from different countries.',
      f1: 'Multi-person video calls, up to 16 users',
      f2: 'Real-time translation, 50+ languages',
      f3: 'Virtual gifts and interactive effects'
    },
    acceleration: {
      title: 'Game Acceleration Solution',
      desc: 'Based on global distributed nodes and intelligent routing algorithms, providing network acceleration services for games, effectively reducing latency and packet loss. Support multiple game protocol optimizations to ensure smooth gaming experience.',
      f1: 'Intelligent routing, reduce latency by 60%+',
      f2: 'Multi-protocol optimization, UDP/TCP acceleration',
      f3: '200+ global nodes, nearest access'
    }
  },
  cases: {
    title: 'Success Stories',
    subtitle: 'Providing professional audio and video communication services for hundreds of gaming companies worldwide',
    moba: {
      title: 'MOBA Competitive Game',
      desc: 'Providing global tournament streaming and team voice services for a renowned MOBA game, supporting 500K+ concurrent users with 18ms latency, ensuring smooth esports events.',
      s1: 'Concurrent Users',
      s2: 'Average Latency',
      s3: 'Uptime'
    },
    battle: {
      title: 'Battle Royale Game',
      desc: 'Providing 100-player room voice communication for battle royale games, 3D spatial audio helps players precisely locate enemies, AI noise reduction ensures clear communication, enhancing competitive gaming experience.',
      s1: 'Room Capacity',
      s2: 'Voice Latency',
      s3: 'User Satisfaction'
    },
    casual: {
      title: 'Social Casual Game',
      desc: 'Providing video calls and streaming services for social gaming platforms, with over 1M daily active users, supporting real-time voice translation, connecting global players for an international social experience.',
      s1: 'Daily Active Users',
      s2: 'Daily Streams',
      s3: 'Retention Rate'
    }
  },
  kol: {
    title: 'KOL Partnership Program',
    subtitle: 'Inviting game streamers and content creators to join CM-Tong partnership program',
    b1: {
      title: 'Dedicated Support',
      desc: 'Dedicated technical team support with priority access to latest features'
    },
    b2: {
      title: 'Revenue Sharing',
      desc: 'Partnership revenue sharing, benefit from platform growth'
    },
    b3: {
      title: 'Brand Exposure',
      desc: 'Official channel promotion to enhance personal brand influence'
    },
    b4: {
      title: 'Priority Benefits',
      desc: 'Priority participation in platform events for more exposure'
    },
    cta: 'Apply for Partnership'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Fill in your requirements and we will contact you within 24 hours',
    name: 'Name',
    email: 'Email',
    company: 'Company Name',
    message: 'Message',
    submit: 'Submit',
    submitting: 'Submitting...',
    success: 'Submitted successfully! We will contact you soon'
  },
  login: {
    title: 'Enterprise Login',
    subtitle: 'Login to your enterprise account to start using CM-Tong platform',
    email: 'Enterprise Email',
    emailPlaceholder: 'Enter your enterprise email',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    remember: 'Remember me',
    forgot: 'Forgot password?',
    submit: 'Login',
    noAccount: "Don't have an account?",
    signup: 'Sign up now',
    back: 'Back to Home'
  },
  footer: {
    desc: 'CM-Tong is a professional AI+WebRTC audio and video platform, providing efficient, low-latency real-time communication solutions for global gaming companies.',
    product: 'Product',
    company: 'Company',
    rights: 'All rights reserved'
  }
};
